import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchEntityDataPoints } from '@/api/my-styles';
import type {
  DataPointResource,
  DetailEntityKind,
} from '@/api/my-styles/types';

const KIND_TO_RESOURCE: Record<DetailEntityKind, DataPointResource> = {
  style: 'styles',
  variant: 'style-variants',
  sku: 'variant-skus',
};

/**
 * The Overview section of the data points in no group. Group ids are
 * lowercase (or the legacy `COMMERCIAL`), so this camelCase key can't clash.
 */
export const OTHER_DATA_POINTS_SECTION = 'otherDataPoints';

export function dataPointResource(kind: DetailEntityKind): DataPointResource {
  return KIND_TO_RESOURCE[kind];
}

/**
 * Every visible data point group of the entity, and its ungrouped data points.
 * Names are dictionary keys, so the response is the same in every language.
 */
export function entityDataPointsQueryOptions(
  kind: DetailEntityKind,
  id: string,
) {
  return queryOptions({
    queryKey: ['my-styles', 'data-points', kind, id] as const,
    queryFn: async () =>
      (await fetchEntityDataPoints(dataPointResource(kind), id)).data,
    enabled: !!id,
  });
}

export function useEntityDataPoints(kind: DetailEntityKind, id: string) {
  return useQuery(entityDataPointsQueryOptions(kind, id));
}
